import React, {memo} from 'react';
import classNames from 'classnames';
import styles from './styles.module.scss';

interface DividerProps {
  vertical?: boolean;
  className?: string;
}

const Divider: React.FC<DividerProps> = ({vertical = false, className = ""}) => {
  const dividerClass = vertical ? styles.vertical : styles.horizontal;

  return <div className={classNames(styles.divider, dividerClass, className)}/>;
};

export default memo(Divider);
